import React, { useState, useEffect } from "react";
import * as S from "./styles";
import * as API from "../../api";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ModuleTareaDatosGenerales } from "../../components/ModuleTareaDatosGenerales";
import { ModuleTareaDatosFormalizacion } from "../../components/ModuleTareaDatosFormalizacion";
import { ModalDocumentos } from "../../components/ModalDocumentos";
import { Button } from "../../components/Button";
import { Loading } from "../../components/Loading";
import {
  METADATA_VISTO_BUENO_SSJJ_DATOS_GENERALES,
  METADATA_VISTO_BUENO_SSJJ_DATOS_FORMALIZACION,
  METADATA_VISTO_BUENO_SSJJ_MOTIVOS,
  METADATA_VISTO_BUENO_SSJJ_DOCS_ACTIVOS,
  METADATA_DOCS_RESERVA,
} from "../../constants";
import { ModuleTablaBasica } from "../../components/ModuleTablaBasica";
import { ModuleTareaDocsReserva } from "../../components/ModuleTareaDocsReserva";
import { ModuleTareaDocsActivos } from "../../components/ModuleTareaDocsActivos";
import { usePermissions } from "../../context/PermissionsContext";

export const MinutaSSJJ = () => {
  const { permissions } = usePermissions();
  const { idTarea } = useParams();
  const navigate = useNavigate();
  const [lists, setLists] = useState({});
  const [datosGenerales, setDatosGenerales] = useState({});
  const [datosFormalizacion, setDatosFormalizacion] = useState({});
  const [motivos, setMotivos] = useState([]);
  const [docsReserva, setDocsReserva] = useState([]);
  const [visibleModal, setVisibleModal] = useState("");
  const [docsActivos, setDocsActivos] = useState([]);
  const [triggerRefresh, setTriggerRefresh] = useState(false);
  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [options, setOptions] = useState({});
  useEffect(() => {
    let isMounted = true;

    API.abrirTarea({ tarea: idTarea })
      .then((res) => {
        if (isMounted) {
          setDatosGenerales(res.datosGenerales);
          setDatosFormalizacion(res.datosFormalizacion);
          setDocsReserva(res.documentosReserva);
          setDocsActivos(res.documentosActivos);
          setMotivos(res.listaMotivosSSJJ);
        }
      })
      .catch((error) => API.DEVELOP && console.log(error))
      .finally(() => setLoading(false));

    API.obtenerListas("MinutaSSJJ", 0)
      .then((res) => isMounted && setLists(res))
      .catch((error) => API.DEVELOP && console.log(error));

    return () => (isMounted = false);
  }, [idTarea]);

  useEffect(() => {
    if (triggerRefresh) {
      API.abrirTarea({ tarea: idTarea }).then((res) => {
        setDocsReserva(res.documentosReserva);
        setDocsActivos(res.documentosActivos);
      });
      setTriggerRefresh(false);
    }
  }, [idTarea, triggerRefresh]);

  useEffect(() => {
    const options = {};
    const values = {};
    Object.entries(lists).forEach(([list, listProps]) => {
      options[list] = convertOptions(listProps.valores);
    });

    const setInitialValue = (e) => {
      switch (e.type) {
        case "text":
        case "textarea":
          values[e.name] = datosFormalizacion[e.name] || "";
          break;

        case "number":
          values[e.name] = datosFormalizacion[e.name];
          break;

        case "checkbox":
          values[e.name] = datosFormalizacion[e.name] || false;
          break;

        case "list":
          values[e.name] =
            datosFormalizacion[e.name]?.valor ||
            lists[e.list]?.valorPorDefecto ||
            "";

          if (lists[e.list]?.listasHijas.length > 0) {
            const field = METADATA_VISTO_BUENO_SSJJ_DATOS_FORMALIZACION.find(
              (field) => field.list === lists[e.list]?.nombreLista
            );
            const tmpOptions = { ...options };

            const listaRelacional = {
              nombreLista: field.list,
              idEntidadRelacional: values[field.name],
            };
            lists[field.list].listasHijas.forEach((list) => {
              const data = {
                lista: list,
                listaRelacional,
              };
              API.obtenerLista(data).then((res) => {
                tmpOptions[list] = convertOptions(res.valores);
                setOptions(tmpOptions);
              });
            });
          }
          break;

        default:
          values[e.name] = "";
      }
    };

    METADATA_VISTO_BUENO_SSJJ_DATOS_FORMALIZACION.forEach((props) => {
      if (props.name === "_group")
        props.fields.forEach((props) => setInitialValue(props));
      else setInitialValue(props);
    });

    setValues(values);
    setOptions(options);
  }, [lists, datosFormalizacion]);

  const convertOptions = (options) =>
    options.map((opt) => ({
      value: opt.valor,
      label: opt.etiqueta,
    }));

  const requestAddReserveDocument = () => {
    setVisibleModal("addReserveDocument");
  };
  const addReserveDocument = (data) => {
    setLoading(true);
    setVisibleModal("");
    data.idTarea = idTarea;

    API.crearDocumentoReserva(data)
      .then((res) => {
        setTriggerRefresh(true);
        toast.success("Documento creado");
      })
      .catch((error) => {
        toast.error("No se pudo crear el documento\n" + error.msg);
        API.DEVELOP && console.log(error);
      })
      .finally(() => setLoading(false));
  };
  const renderModal = () => {
    switch (visibleModal) {
      case "addReserveDocument":
        return (
          <ModalDocumentos
            type="addDocument"
            title="Nuevo tipo de documento"
            labelConfirm="Guardar"
            lists={lists}
            documentsListName="TipoDocumentoReserva"
            confirm={addReserveDocument}
            cancel={() => setVisibleModal("")}
          />
        );

      default:
        return null;
    }
  };
  const guardarCompletarVistoBuenoSSJJ = (esCompletar) => {
    setLoading(true);
    API.guardarCompletarTareaMinutaSSJJ({
      IdTarea: idTarea,
      Completar: esCompletar,
      VistoBuenoSSJJ: values["vistoBuenoSSJJ"],
      ComentarioVistoBuenoSSJJ: values["comentarioVistoBuenoSSJJ"],
    })
      .then((res) => {
        if (res.resultadoPeticion === 1 && esCompletar === true) {
          toast.success("Tarea Completada");
          navigate("/");
        } else if (res.resultadoPeticion === 1 && esCompletar === false) {
          toast.success("Tarea Guardada");
        } else toast.error(res.mensajeUsuario);
      })
      .catch((error) => API.DEVELOP && console.log(error))
      .finally(() => setLoading(false));
  };

  return (
    <S.Wrapper>
      {loading && <Loading />}
      {visibleModal && renderModal()}

      <ModuleTareaDatosGenerales
        data={datosGenerales}
        metadata={METADATA_VISTO_BUENO_SSJJ_DATOS_GENERALES}
      />

      <ModuleTareaDatosFormalizacion
        data={datosFormalizacion}
        metadata={METADATA_VISTO_BUENO_SSJJ_DATOS_FORMALIZACION}
        lists={lists}
        columns={4}
        values={values}
        setValues={setValues}
        options={options}
        setOptions={setOptions}
        access={permissions.MinutaSSJJ}
      />

      <ModuleTareaDocsReserva
        data={docsReserva}
        metadata={METADATA_DOCS_RESERVA}
        requestAdd={requestAddReserveDocument}
        refreshDocs={() => setTriggerRefresh(true)}
        setLoading={setLoading}
        access={permissions.MinutaSSJJ}
      />

      <ModuleTareaDocsActivos
        data={docsActivos}
        metadata={METADATA_VISTO_BUENO_SSJJ_DOCS_ACTIVOS}
        refreshDocs={() => setTriggerRefresh(true)}
        setLoading={setLoading}
      />

      <ModuleTablaBasica
        data={motivos}
        metadata={METADATA_VISTO_BUENO_SSJJ_MOTIVOS}
        label="Motivos"
      />

      <S.Buttons>
        <a
          href={`/FichaReserva/${datosGenerales.idReserva}`}
          target="_blank"
          rel="noreferrer"
        >
          <Button label="Ver Ficha" disabled={!datosGenerales.idReserva} />
        </a>
        <div>
          <Button
            label="Guardar"
            onClick={() => guardarCompletarVistoBuenoSSJJ(false)}
          />
          <Button
            label="Completar"
            onClick={() => guardarCompletarVistoBuenoSSJJ(true)}
          />
        </div>
      </S.Buttons>
    </S.Wrapper>
  );
};
